import { render, staticRenderFns } from "./IpList.vue?vue&type=template&id=e260665a&"
import script from "./IpList.vue?vue&type=script&lang=js&"
export * from "./IpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports